import React from 'react';
import { Provider } from 'react-redux';

import Head from 'next/head';
import Script from 'next/script';
import type { AppProps } from 'next/app';

import { Hotjar } from 'shared/util/hotjar';

import { wrapper } from '@/state/store';
import { UnleashProvider } from '@/hooks/unleash';

import '@/server/assets/styles/common-pale.css';

declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

const PrepackageApp = ({ Component, pageProps }: AppProps) => {
    const store = wrapper.useStore();

    return (
        <>
            <Head>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta
                    name="description"
                    content="Finn billige pakkereiser fra alle reisebyrå på ett sted! På FINN.no kan du sammenligne priser og spare penger."
                />
                <meta
                    property="og:description"
                    content="Finn billige pakkereiser fra alle reisebyrå på ett sted! På FINN.no kan du sammenligne priser og spare penger."
                />
                <meta property="og:image" content="https://www.finn.no/assets/finn-logo-large.png" />
                <meta property="og:url" content="https://www.finn.no/reise/pakkereiser/resultat" />
            </Head>
            <Provider store={store}>
                <UnleashProvider toggles={pageProps.unleash}>
                    <Component {...pageProps} />
                </UnleashProvider>
            </Provider>
            {/* Error pages won't get Hotjar as they don't load middleware */}
            <Hotjar enabled={pageProps.unleash?.hotjar && pageProps.hasLegalBasis} />
            <Script
                src="https://cdn.trackjs.com/agent/v3/latest/t.js"
                onLoad={() => {
                    window.TrackJS?.install?.({
                        token: '74bb3e28a1604fd2b28c72c568722d21',
                        application: 'finn-travel-prepackage',
                        version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                        enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                    });
                }}
                crossOrigin=""
            />
        </>
    );
};

export default PrepackageApp;
